/* Redactor Vue Component Version 1.0.0 Updated: August 23, 2018
http://imperavi.com/redactor/ Copyright 2018, Imperavi Ltd. License: MIT */

<template>
  <textarea
    ref="redactor"
    :name="name"
    :placeholder="placeholder"
    :value="value"
  />
</template>

<style lang="less">
.redactor-box {
  border: none !important;
}

.redactor-styles {
  padding: 0 !important;
}

.redactor-toolbar {
  padding: 0 16px 8px 0 !important;
  a {
    font-size: 12px !important;
  }
}
</style>

<script>
require("@/vendor/redactor/redactor");
require("@/vendor/redactor/redactor.css");
var Vue = require("vue").default;

export default {
  redactor: false,
  props: {
    value: {
      default: "",
      type: String
    },
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    config: {
      default: {},
      type: Object
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (!this.redactor.editor.isFocus())
        this.redactor.source.setCode(newValue);
    },
    'config.placeholder'(newValue, oldValue) {
      let placeholderElem = this.$refs.redactor.parentNode.getElementsByClassName('redactor-placeholder');
      if (placeholderElem.length) {
        placeholderElem[0].setAttribute('placeholder', newValue);
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var me = this;
      var callbacks = {
        changed: function(html) {
          me.handleInput(html);
          return html;
        }
      };

      // extend config
      Vue.set(this.config, "callbacks", callbacks);

      // call Redactor
      var app = $R(this.$refs.redactor, this.config);

      // set instance
      this.redactor = app;
      this.$parent.redactor = app;
    },
    handleInput(val) {
      this.$emit("input", val);
    }
  }
};
</script>
